export default "__VITE_ASSET__BQeGB7SK__"